import _ from "lodash";
import { translation } from '@/plugins/i18n';
import MessageBox from '@zoom/zoom-ui/src/components/message-box/message-box';
import { pageConfig } from '@/common/service/page-config';
import store from '@/store';
import { validateAssignLicense } from '@/apis/validate';

const PAY_BY_CHECK_UPGRADE_QUERY_KEY = 'payByCheckUpgrade';

export const beforeCheckForCoupon = async () => {
  // check for JW Migration unAssign license check
  await preCheckForPayByCheckUpgradeAssignInfo();
};

const popUpMessageWithAssign = (options = {}) => {
  return MessageBox.alert(options?.errorMessage, translation('billing.common.can_not_continue'));
};

export const preCheckForPayByCheckUpgradeAssignInfo = async () => {
  const { fromCampaignLink, orderDataPayload } = store.getters;
  const isPayByCheckForUpgrade = _.get(pageConfig, PAY_BY_CHECK_UPGRADE_QUERY_KEY, false);

  // from campaign link & jw migrate (pay by check account migrate to paid account)
  if (fromCampaignLink && isPayByCheckForUpgrade) {
    await validateAssignLicense(orderDataPayload)
      .catch((result) => {
        popUpMessageWithAssign(result);
        return Promise.reject();
      });
  }

  return Promise.resolve();
};
